export default __webpack_public_path__ + "static/media/manager.e7043fbc.png";